module.exports = __webpack_public_path__ + "static/img/invitebg.3b9bf08.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/invitebg.webp
// module id = gyq0
// module chunks = 0